import { Observable } from "rxjs";
import {
  Fattura,
  FattureQueryParams,
  ImportFattureRequestDto,
  ImportFattureResponseDto, LottoPassivoSummaryDto,
  PaginatedResponse
} from "../../models/fatture.model";

export abstract class FatturePort {
  abstract getList(params?: FattureQueryParams): Observable<PaginatedResponse<Fattura>>;
  abstract getById(id: number): Observable<Fattura>;

  abstract importXml(file: File): Observable<void>;

  abstract setStatoFiscale(id: number, statoFiscale: string): Observable<void>;
  abstract setAsCostoFisso(id: number): Observable<void>;

  abstract associateFornitore(id: number, idFornitore: number): Observable<void>;
  abstract endFornitoreAssociation(id: number): Observable<void>;

  abstract associateCantiere(id: number, idCantiere: number): Observable<void>;
  abstract endCantiereAssociation(id: number): Observable<void>;

  abstract associateArticoloCantiere(idArticolo: number, idCantiere: number): Observable<void>;
  abstract endArticoloCantiereAssociation(idArticolo: number): Observable<void>;

  abstract getLottiSdiToImport(year: number): Observable<LottoPassivoSummaryDto[]>;

  abstract importLottiSdi(
    request: ImportFattureRequestDto
  ): Observable<ImportFattureResponseDto>;

  abstract downloadOriginalFile(fileId: number): Observable<Blob>;
}
